import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import NotFound from '@/views/NotFound.vue'
import NewsView from '@/views/NewsView.vue'
import InstallationsView from '@/views/InstallationsView.vue'
import AboutView from '@/views/AboutView.vue'
// import MapView from '@/views/MapView.vue'
import LoginView from '@/views/LoginView.vue'
import AdminView from '@/views/AdminView.vue'
import NewsItemView from '@/views/NewsItemView.vue'
import InstallationView from '@/views/InstallationView.vue'

import TestView from '@/views/TestView.vue'
import TermsOfService from '@/views/TermsOfService.vue'
import getCurrentUser from '@/exports/getCurrentUser'

import store from "@/store/index.js"

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/aktuelt',
    name: 'aktuel',
    component: NewsView
  },
  {
    path: '/installasjonene',
    name: 'installasjonene',
    component: InstallationsView
  },
  {
    path: '/om-poesiparken',
    name: 'om-poesiparken',
    component: AboutView
  },
  {
    path: '/kart',
    name: 'kart',
    component: TestView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/admin-panel',
    name: 'Admin panel',
    component: AdminView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: NotFound
  },
  {
    path: '/aktuelt/:title&:content&:img&:description',
    name: 'aktuelt',
    component: NewsItemView
  },
  {
    path: '/installasjon/:id',
    name: 'installasjon',
    component: InstallationView,
    props: true
  },
  {
    path: '/tilgjengelighetserklæring',
    name: 'tos',
    component: TermsOfService
  },

  // {
  //   path: '/test',
  //   name: 'test',
  //   component: TestView,
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// router.beforeEach(async (to) => {
//   const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
//   if (requiresAuth && !await getCurrentUser()) {
//     return '/login';
//   } 
// })
router.beforeEach(async (to, from, next) => {
  const user = await getCurrentUser(); // may be null if not signed in
  const admins = store.state.admins || [];
  const adminUids = admins.map(u => u.uid);

  // If route requires admin access
  if (to.meta.requiresAdmin) {
    if (!user || !adminUids.includes(user.uid)) {
      return next('/'); // redirect non-admins or anonymous users
    }
  }

  // Otherwise, allow access (auth optional)
  return next();
});
export default router
